(() => {
  const root = document.documentElement;
  const header = document.querySelector(".shopify-section--header");
  const announcementBar = document.querySelector("announcement-bar");
  let headerHeight;
  let announcementBarHeight;

  const updateLayoutVariables = () => {
    if (header) {
      const nextHeaderHeight = header.getBoundingClientRect().height;

      if (nextHeaderHeight !== headerHeight) {
        headerHeight = nextHeaderHeight;
        root.style.setProperty("--header-height", `${headerHeight}px`);
      }
    }

    if (announcementBar) {
      const nextAnnouncementBarHeight =
        announcementBar.getBoundingClientRect().height;

      if (nextAnnouncementBarHeight !== announcementBarHeight) {
        announcementBarHeight = nextAnnouncementBarHeight;
        root.style.setProperty(
          "--announcement-bar-height",
          `${announcementBarHeight}px`,
        );
      }
    }
  };

  updateLayoutVariables();

  const initializationStartedAt = performance.now();
  const updateDuringInitialization = () => {
    updateLayoutVariables();

    if (performance.now() - initializationStartedAt < 4000) {
      requestAnimationFrame(updateDuringInitialization);
    }
  };

  requestAnimationFrame(updateDuringInitialization);

  if (!window.ResizeObserver) {
    return;
  }

  window.layoutVariablesObserver?.disconnect();
  window.layoutVariablesObserver = new ResizeObserver(updateLayoutVariables);

  if (header) {
    window.layoutVariablesObserver.observe(header);
  }

  if (announcementBar) {
    window.layoutVariablesObserver.observe(announcementBar);
  }
})();
